import styled from "styled-components";

export const Text = styled.div<{ hasZeroConditions: boolean }>`
	color: ${(props) => (props.hasZeroConditions ? "red" : "black")};
`;
